var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 20.2C3.5 20.3657 3.63431 20.5 3.8 20.5H6.2C6.36569 20.5 6.5 20.3657 6.5 20.2V15.8C6.5 15.6343 6.36569 15.5 6.2 15.5H3.8C3.63431 15.5 3.5 15.6343 3.5 15.8V20.2Z",
    fill: "#646D7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 20.2C8.5 20.3657 8.63431 20.5 8.8 20.5H11.2C11.3657 20.5 11.5 20.3657 11.5 20.2V11.8C11.5 11.6343 11.3657 11.5 11.2 11.5H8.8C8.63431 11.5 8.5 11.6343 8.5 11.8V20.2Z",
    fill: "#646D7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 20.2C13.5 20.3657 13.6343 20.5 13.8 20.5H16.2C16.3657 20.5 16.5 20.3657 16.5 20.2V7.8C16.5 7.63432 16.3657 7.5 16.2 7.5H13.8C13.6343 7.5 13.5 7.63431 13.5 7.8V20.2Z",
    fill: "#646D7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 20.2C18.5 20.3657 18.6343 20.5 18.8 20.5H21.2C21.3657 20.5 21.5 20.3657 21.5 20.2V3.8C21.5 3.63431 21.3657 3.5 21.2 3.5H18.8C18.6343 3.5 18.5 3.63431 18.5 3.8V20.2Z",
    fill: "#646D7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.d344aafcfbea72d7c5ac1ca608475d73.svg";
export { ForwardRef as ReactComponent };